import React, { useState } from 'react';

const FaqItem = ({ question, answer, active, onClick }) => {
  return (
    <div className={`faq-item ${active ? 'faq-active' : ''}`} onClick={onClick}>
      <i className="faq-icon bi bi-question-circle"></i>
      <h3>{question}</h3>
      <div className="faq-content">
        <p>{answer}</p>
      </div>
      <i className="faq-toggle bi bi-chevron-right"></i>
    </div>
  );
};

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqItems = [
    {
      question: 'What is TallyPrime?',
      answer: ' TallyPrime is a popular business accounting and financial management software developed by Tally Solutions. It is designed to simplify complex accounting processes and provide businesses with the tools they need for effective financial management.'
    },
    {
      question: 'What is DigiCloud?',
      answer: 'DigiCloud is a popular business accounting and financial management software developed by Tally Solutions. It is designed to simplify complex accounting processes and provide businesses with the tools they need for effective financial management.'
    },
    {
      question: 'What is SharePro?',
      answer: 'The SharePro Desktop is the core-component of the SharePro Backoffice Suite. As a vital companion in your business operations – this acts as a  backbone for all your backoffice requirements. The teams at HO use this application to manage and run the broking show. Easy to use, easy to learn and extremely powerful, the SharePro Desktop is the heart of the whole operation of your business.'
    }
  ];

  const handleFaqClick = (index) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };

  return (
    <section id="faq" className="faq section light-background">
      <div className="container-fluid">
        <div className="row gy-4">
          <div className="col-lg-7 d-flex flex-column justify-content-center order-2 order-lg-1">
            <div className="content px-xl-5" data-aos="fade-up" data-aos-delay="100">
              <h3><span>Frequently Asked </span><strong>Questions</strong></h3>
              <p>
              Get clarity on our software, services, and solutions to make informed decisions for your business.
              </p>
            </div>

            <div className="faq-container px-xl-5" data-aos="fade-up" data-aos-delay="200">
              {faqItems.map((item, index) => (
                <FaqItem 
                  key={index}
                  question={item.question}
                  answer={item.answer}
                  active={index === activeIndex}
                  onClick={() => handleFaqClick(index)}
                />
              ))}
            </div>
          </div>

          <div className="col-lg-5 order-1 order-lg-2">
            <img src="/assets/img/faq.jpg" className="img-fluid" alt="" data-aos="zoom-in" data-aos-delay="100" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq; 